import styles from './cardCarouselLoader.module.scss';

export const CardCarouselLoader = () => {
    return <div className={styles.cardCarouselLoader}></div>;
};
